var o = Object.prototype, r = o.toString;
function e(t) {
  return r.call(t);
}
export {
  e as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_objectToString.js
// module id = 1498
// module chunks = 41